import { API2_HOST } from '@/utils/constants';

import fetchData from './http';

const WRITE_COOKIE = `${API2_HOST}/oauth/v1/public/detector/implant`;
const DETECT_VERSION = `${API2_HOST}/oauth/v1/public/detector/inspect`;

export const whiteCookie = () => {
  return fetchData
    .post<Promise<{ result: any }>>(WRITE_COOKIE)
    .then((res: any) => {
      return res?.result;
    })
    .catch(() => {
      return false;
    });
};

export const detectVersion = () => {
  return fetchData
    .post<Promise<{ result: any }>>(DETECT_VERSION)
    .then((res: any) => {
      return res?.result;
    })
    .catch(() => {
      return true;
    });
};
